// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-link {
  display: block;
  margin-top: 25px;
  text-align: center;
}

.lr-edit-btn {
  background: none;
  border: none;
  margin-left: 50px;
}

.lr-center-radio {
  margin: 0px auto !important;
}

.lr-radio-edit {
  margin-left: 100px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/contact-information/preferred-phone/preferred-phone.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".lr-link {\n  display: block;\n  margin-top: 25px;\n  text-align: center;\n}\n\n.lr-edit-btn {\n  background: none;\n  border: none;\n  margin-left: 50px;\n}\n\n.lr-center-radio {\n  margin: 0px auto !important;\n}\n\n.lr-radio-edit {\n  margin-left: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
